import { ElMessage } from "element-plus";

const clipboard = {
  mounted(el, binding) {
    if (binding.arg === 'copy') {
      el._copyValue = binding.value;
      el.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(el._copyValue);
          ElMessage.success(`复制成功`);          
        } catch (err) {
          console.error('Copy failed', err);
          ElMessage.error(`复制失败`);
        }
      });
    }
  },
  updated(el, binding) {
    if (binding.arg === 'copy') {
      el._copyValue = binding.value;
    }
  },
  unmounted(el) {
    el.removeEventListener('click', el._clickHandler);
  }
};

export default clipboard;
